import { FC, ReactNode, useEffect } from "react";
import {
  MenuListParams,
  SaveSearchFilterParams,
} from "../../api/services/client/models";
import { isEmpty } from "../../helpers/utils";
import { MuiBox } from "../box/MuiBox";
import { MuiIconButton } from "../button/MuiButton";
import { MuiModal } from "../modal/MuiModal";
import { MuiTypography } from "../typography/MuiTypography";
import { CommonListModalWrapper } from "./CommonListModal.style";

type CommonListModalProps = {
  title: string;
  open: boolean;
  iconButtonTitle?: string;
  onIconButtonClick?: (
    event: React.MouseEvent<HTMLButtonElement>,
    item: MenuListParams,
  ) => void;
  listItems?: MenuListParams[] | SaveSearchFilterParams[];
  buttonIcon?: ReactNode;
  closeHandler: () => void;
  onFilterClick: (item: MenuListParams | SaveSearchFilterParams) => void;
  secondaryButtonTitle: string;
};

export const CommonListModal: FC<CommonListModalProps> = ({
  title = "Saved Filter",
  open,
  iconButtonTitle,
  onIconButtonClick,
  listItems,
  buttonIcon,
  closeHandler,
  onFilterClick,
  secondaryButtonTitle,
}) => {
  // Close modal automatically if no items and it's open
  useEffect(() => {
    if (open && isEmpty(listItems)) {
      closeHandler();
    }
  }, [open, listItems, closeHandler]);

  if (isEmpty(listItems)) {
    return null;
  }
  return (
    <MuiModal
      open={open}
      onClose={closeHandler}
      title={title}
      className="manage-local-modal"
      secondaryButtonTitle={secondaryButtonTitle}
      onSecondaryButtonClick={closeHandler}
    >
      <CommonListModalWrapper>
        {listItems?.map((item: MenuListParams | SaveSearchFilterParams) => (
          <MuiBox key={item.id} className="list-item-container">
            <MuiBox className="item-title" onClick={() => onFilterClick(item)}>
              <MuiTypography variant="h3Bold">{item.name}</MuiTypography>
            </MuiBox>
            {buttonIcon && (
              <MuiIconButton onClick={(e) => onIconButtonClick?.(e, item)}>
                {buttonIcon}
              </MuiIconButton>
            )}
          </MuiBox>
        ))}
      </CommonListModalWrapper>
    </MuiModal>
  );
};
